import type { FC, ReactNode} from 'react';
import { createContext, useContext } from 'react';

import { Api } from '../../api';
import { Context as WidgetSettingsContext } from '../WidgetSettingsProvider/WidgetSettingsProvider';

export const Context = createContext<Api | null>(null);

interface Props {
    children: ReactNode;
}

export const Provider: FC<Props> = ({ children }) => {
    const configuration = useContext(WidgetSettingsContext);
    if (!configuration) {
        throw new Error('ApiProvider requires WidgetSettingsProvider');
    }
    return <Context.Provider value={new Api(configuration)}>{children}</Context.Provider>;
};
